"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.upload = void 0;
const headers_1 = require("../utils/headers");
const http_1 = require("../utils/http");
const socEndpoint = 'soc';
/**
 * Upload single owner chunk (SOC) to a Bee node
 *
 * @param ky Ky instance
 * @param owner           Owner's ethereum address in hex
 * @param identifier      Arbitrary identifier in hex
 * @param signature       Signature in hex
 * @param data            Content addressed chunk data to be uploaded
 * @param postageBatchId  Postage BatchId that will be assigned to uploaded data
 * @param options         Additional options like tag, encryption, pinning
 */
async function upload(requestOptions, owner, identifier, signature, data, postageBatchId, options) {
    const response = await (0, http_1.http)(requestOptions, {
        method: 'post',
        url: `${socEndpoint}/${owner}/${identifier}`,
        data,
        headers: {
            'content-type': 'application/octet-stream',
            ...(0, headers_1.extractUploadHeaders)(postageBatchId, options),
        },
        responseType: 'json',
        params: { sig: signature },
    });
    return response.data.reference;
}
exports.upload = upload;
